import type { AtomModel } from '@models/atom.model';

import type { AtomWithTitle } from '@/types/atom';

export const atomHasTitle = (atom: AtomModel): atom is AtomWithTitle =>
  !!atom.data &&
  typeof atom.data === 'object' &&
  'title' in atom.data &&
  typeof atom.data.title === 'string';

export const isFieldRequired = (atom: AtomWithTitle): boolean => {
  if ('required' in atom.data && typeof atom.data.required === 'boolean') {
    return atom.data.required;
  }
  return false; // This should never happen, but we'll return false to make the data possibly undefined in case
};
